import inlineSVG from '@/helpers/inlineSVG.coffee'
export default
  inlineSVG: (id) ->
    if id == undefined
      inlineSVG.inlineSVGClass()
    else
      inlineSVG.inlineSVGId(id)
  inlineSVGId: (id) ->
    element = document.getElementById(id)
    if element == undefined
      return
    if element == null
      return
    inlineSVG.inlineSVGElement(element)
  inlineSVGClass: ->
    elements = document.getElementsByClassName('inlineSVG')
    if elements == undefined
      return
    if elements == null
      return
    if elements.length < 0
      return
    Array.from(elements).forEach (element, i) ->
      inlineSVG.inlineSVGElement(element)
  inlineSVGElement: (element) ->
    elementSRC = element.getAttribute('src')
    if typeof elementSRC == undefined
      return
    if elementSRC == undefined
      return
    if elementSRC == null
      return
    response = await fetch(elementSRC)
    text = await response.text()

    parser = new DOMParser
    xmlDoc = parser.parseFromString text, "text/xml"

    # Get the SVG tag, ignore the rest
    SVG = xmlDoc.getElementsByTagName('svg')[0]

    if typeof SVG == undefined
      return
    if SVG == undefined
      return

    # Remove any invalid XML tags as per http://validator.w3.org
    SVG.removeAttribute('xmlns:a')

      # Check if the viewport is set, if the viewport is not set the SVG wont't scale.
    if (!SVG.getAttribute('viewBox') && SVG.getAttribute('height') && SVG.getAttribute('width'))
      SVG.setAttribute('viewBox', '0 0 ' + SVG.getAttribute('height') + ' ' + SVG.getAttribute('width'))

    element.innerHTML = SVG.innerHTML
    element.setAttribute('xmlns', SVG.getAttribute('xmlns'))
    element.setAttribute('viewBox', SVG.getAttribute('viewBox'))
    element.setAttribute('role', 'none')
    element.removeAttribute('src')
